/*
==========================================================================
FUTUREMAXX LANDING PAGES — CORE JS
==========================================================================
Contains: scroll reveal (IntersectionObserver), nav scroll shrink,
Machbar hero typewriter + sparks generator.
Loaded via {{ 'fx-lp-core.js' | asset_url | script_tag }} in layout.
All handlers check for element existence, no hard fails.
IntersectionObserver used for performance (starts animations only in viewport).
==========================================================================
*/
(function(){
'use strict';
/* -------- REVEAL ON SCROLL -------- */
var reveals = document.querySelectorAll('.fx-lp .lp-reveal');
if(reveals.length && 'IntersectionObserver' in window){
var io = new IntersectionObserver(function(entries){
entries.forEach(function(e){
if(e.isIntersecting){
e.target.classList.add('lp-in');
io.unobserve(e.target);
}
});
}, {threshold:.12, rootMargin:'0px 0px -50px 0px'});
reveals.forEach(function(el){io.observe(el);});
}
/* -------- NAV SCROLL SHRINK -------- */
var nav = document.querySelector('.fx-lp .fx-lp-nav');
if(nav){
var lastScrolled = false;
function updateNav(){
var scrolled = window.scrollY > 20;
if(scrolled !== lastScrolled){
nav.classList.toggle('lp-scrolled', scrolled);
lastScrolled = scrolled;
}
}
window.addEventListener('scroll', updateNav, {passive:true});
updateNav();
}
/* -------- MACHBAR HERO: SPARKS -------- */
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var sparks = document.getElementById('fxlpSparks');
if(sparks && !reduce){
var frag = '';
for(var i=0;i<22;i++){
var left = Math.round(Math.random()*100);
var top = 20 + Math.round(Math.random()*70);
var dur = (5 + Math.random()*5).toFixed(1);
var del = (Math.random()*6).toFixed(1);
var cls = Math.random()<0.4 ? 'spark small' : 'spark';
frag += '<span class="'+cls+'" style="left:'+left+'%;top:'+top+'%;--dur:'+dur+'s;--del:'+del+'s"></span>';
}
sparks.innerHTML = frag;
}
/* -------- MACHBAR HERO: TYPEWRITER -------- */
var manifest = document.getElementById('fxlpManifest');
if(manifest){
function splitToChars(node, chars){
var kids = Array.prototype.slice.call(node.childNodes);
kids.forEach(function(child){
if(child.nodeType === 3){
var text = child.textContent;
if(!text) return;
var frag = document.createDocumentFragment();
for(var i=0;i<text.length;i++){
var s = document.createElement('span');
s.className = 'ch';
s.textContent = text[i];
frag.appendChild(s);
chars.push(s);
}
node.replaceChild(frag, child);
} else if(child.nodeType === 1){
if(child.classList && child.classList.contains('lp-mb-cursor')) return;
splitToChars(child, chars);
}
});
}
var line1 = manifest.querySelector('.lp-line-1');
var line2 = manifest.querySelector('.lp-line-2');
if(line1 && line2){
var chars1 = [];
var chars2 = [];
splitToChars(line1, chars1);
splitToChars(line2, chars2);
manifest.classList.add('lp-typing');
function typeChars(chars, delay){
return new Promise(function(resolve){
var i = 0;
function step(){
if(i >= chars.length){ resolve(); return; }
chars[i].classList.add('lp-on');
i++;
setTimeout(step, delay);
}
step();
});
}
function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
async function run(){
if(reduce){
chars1.concat(chars2).forEach(function(c){ c.classList.add('lp-on'); });
manifest.classList.add('lp-done');
return;
}
await wait(450);
manifest.classList.add('lp-line1-typing');
await typeChars(chars1, 32);
manifest.classList.remove('lp-line1-typing');
manifest.classList.add('lp-line1-done');
await wait(650);
manifest.classList.remove('lp-line1-done');
await typeChars(chars2, 115);
manifest.classList.add('lp-done');
}
run();
}
}
})();
/* =========================================================================
ÜBER UNS: stagger reveal, timeline scroll-progress, count-up animation
========================================================================= */
(function(){
'use strict';
/* -------- STAGGERED REVEAL (for card grids) -------- */
var staggerEls = document.querySelectorAll('.fx-lp .lp-reveal-stagger');
if(staggerEls.length && 'IntersectionObserver' in window){
var ioStagger = new IntersectionObserver(function(entries){
entries.forEach(function(en){
if(en.isIntersecting){ en.target.classList.add('lp-in'); ioStagger.unobserve(en.target); }
});
}, {rootMargin:'-40px'});
staggerEls.forEach(function(el){ ioStagger.observe(el); });
}
/* -------- TIMELINE SCROLL PROGRESS -------- */
var timelines = document.querySelectorAll('.fx-lp .lp-timeline__list');
timelines.forEach(function(list){
var items = list.querySelectorAll('.lp-timeline__item');
if(!items.length) return;
function update(){
var rect = list.getBoundingClientRect();
var vh = window.innerHeight;
var center = vh * 0.5;
var top = rect.top;
var bot = rect.bottom;
var progress = 0;
if(top < center){
var travel = (center - top) / (bot - top);
progress = Math.min(1, Math.max(0, travel));
}
list.style.setProperty('--progress', (progress * 100) + '%');
items.forEach(function(it){
var itRect = it.getBoundingClientRect();
if(itRect.top < center){ it.classList.add('lp-reached'); }
else { it.classList.remove('lp-reached'); }
});
}
update();
window.addEventListener('scroll', update, {passive:true});
window.addEventListener('resize', update);
});
/* -------- COUNT-UP ANIMATION (Kundenstamm stats) -------- */
var counters = document.querySelectorAll('.fx-lp .lp-kstat__num[data-count]');
if(counters.length && 'IntersectionObserver' in window){
function countUp(el){
var target = parseInt(el.dataset.count, 10);
var suffix = el.dataset.suffix || '';
var prefix = el.dataset.prefix || '';
var isYear = target >= 1000;
var duration = isYear ? 1400 : 1000;
var start = performance.now();
var from = isYear ? target - 30 : 0;
function tick(now){
var t = Math.min(1, (now - start) / duration);
var eased = 1 - Math.pow(1 - t, 3);
var val = Math.floor(from + (target - from) * eased);
el.textContent = prefix + val + suffix;
if(t < 1) requestAnimationFrame(tick);
}
requestAnimationFrame(tick);
}
var ioCount = new IntersectionObserver(function(entries){
entries.forEach(function(en){
if(en.isIntersecting){ countUp(en.target); ioCount.unobserve(en.target); }
});
}, {threshold: 0.5});
counters.forEach(function(el){ ioCount.observe(el); });
}
})();
/* =========================================================================
LEISTUNGEN: flip cards, marketing-werkstatt cards, interactive quiz
========================================================================= */
(function(){
'use strict';
/* -------- SERVICE FLIP CARDS -------- */
document.querySelectorAll('.fx-lp .lp-flip-card').forEach(function(card){
var moreBtn = card.querySelector('.lp-svc__more');
var backBtn = card.querySelector('.lp-svc__back-btn');
if(moreBtn) moreBtn.addEventListener('click', function(){
card.classList.add('lp-flipped');
moreBtn.setAttribute('aria-expanded', 'true');
});
if(backBtn) backBtn.addEventListener('click', function(){
card.classList.remove('lp-flipped');
if(moreBtn) moreBtn.setAttribute('aria-expanded', 'false');
});
});
/* -------- MARKETING-WERKSTATT FLIP CARDS -------- */
document.querySelectorAll('.fx-lp .lp-mwerk__area').forEach(function(card){
var moreBtn = card.querySelector('.lp-mwerk__more');
var backBtn = card.querySelector('.lp-mwerk__back-btn');
if(moreBtn) moreBtn.addEventListener('click', function(){
card.classList.add('lp-flipped');
moreBtn.setAttribute('aria-expanded', 'true');
});
if(backBtn) backBtn.addEventListener('click', function(){
card.classList.remove('lp-flipped');
if(moreBtn) moreBtn.setAttribute('aria-expanded', 'false');
});
});
/* -------- INTERACTIVE QUIZ (3-step service profile) -------- */
var quizRoot = document.querySelector('.fx-lp .lp-quiz__container');
if(!quizRoot) return;
var selected = new Set();
var answers = [];
var current = 0;
// Questions come from a data attribute (JSON) on the quiz container
var QUESTIONS;
try { QUESTIONS = JSON.parse(quizRoot.dataset.questions || '[]'); }
catch(e){ QUESTIONS = []; }
if(!QUESTIONS.length){
QUESTIONS = [
{ key:'prozesse', service:'portal', text:'Rechnungen, Angebote und Bestellungen laufen bei uns automatisch — ohne dass jemand sie manuell tippen muss.' },
{ key:'team', service:'schulung', text:'Unser Team hat ein einheitliches System für Aufgaben, Termine und Kommunikation — nichts läuft nur per WhatsApp oder E-Mail.' },
{ key:'kunden', service:'shop', text:'Unsere Kunden können bei uns online buchen, kaufen oder anfragen — auch ohne persönlichen Kontakt.' },
{ key:'daten', service:'portal', text:'Wir können jederzeit auf Knopfdruck sagen, wie viel Umsatz wir diesen Monat gemacht haben — ohne Excel zu bemühen.' },
{ key:'sichtbarkeit',service:'marketing', text:'Neue Kunden finden uns über Google oder Empfehlungen — nicht nur über bekannte Kontakte.' }
];
}
var LABEL_MAP = {
shop:{label:'Shop',color:'shop'},
portal:{label:'Portal / System',color:'portal'},
website:{label:'Website',color:'website'},
beratung:{label:'Beratung + Hardware',color:'beratung'},
schulung:{label:'Schulung',color:'schulung'},
marketing:{label:'Marketing',color:'marketing'},
ki:{label:'KI & Automation',color:'ki'},
unclear:{label:'Beratung — noch unklar',color:'beratung'}
};
var REASONS = {
portal:'Ohne strukturierte Prozesse und klare Daten-Übersicht wird jedes andere System schnell zur Belastung.',
schulung:'Die beste Software nutzt nichts, wenn das Team damit nicht sicher umgehen kann.',
shop:'Kunden erwarten heute Online-Zugang — auch bei traditionellen Betrieben.',
marketing:'Selbst das beste Produkt braucht Sichtbarkeit, sonst kommt niemand darauf.',
website:'Eine saubere Firmenpräsentation ist die Basis für alle weiteren digitalen Kanäle.'
};
var blocks = quizRoot.querySelectorAll('.lp-qblock');
var cart = quizRoot.querySelector('.lp-quiz__cart');
var qNext1 = quizRoot.querySelector('[data-step="1"] .lp-qbtn--next');
var qBack2 = quizRoot.querySelector('[data-step="2"] .lp-qbtn--back');
var qProgress = quizRoot.querySelector('.lp-quiz__progress');
var qQNum = quizRoot.querySelector('.lp-qquestion__label');
var qQText = quizRoot.querySelector('.lp-qquestion__text');
var qOpts = quizRoot.querySelectorAll('.lp-qopt');
var qScore = quizRoot.querySelector('.lp-qresult__scoreValue span');
var qLevel = quizRoot.querySelector('.lp-qresult__scoreLevel');
var qSelectedChips = quizRoot.querySelector('.lp-qresult__block .lp-qresult__chips');
var suggestBlocks = quizRoot.querySelectorAll('.lp-qresult__block');
var qSuggestBlock = suggestBlocks[1];
var qSufficientBlock = suggestBlocks[2];
var qSuggestedChips = qSuggestBlock ? qSuggestBlock.querySelector('.lp-qresult__chips') : null;
var qReasoning = qSuggestBlock ? qSuggestBlock.querySelector('.lp-qresult__reasoning') : null;
var qReasoningOK = qSufficientBlock ? qSufficientBlock.querySelector('.lp-qresult__reasoning') : null;
var qCta = quizRoot.querySelector('.lp-qresult__cta .lp-qbtn--gold');
var qRestart = quizRoot.querySelector('.lp-qresult__restart');
var kontaktUrl = quizRoot.dataset.kontaktUrl || '/pages/kontakt';
function goStep(n){
quizRoot.querySelectorAll('.lp-quiz__step').forEach(function(s){s.classList.toggle('lp-active', +s.dataset.step === n);});
quizRoot.querySelectorAll('.lp-qstep').forEach(function(s){
var num = +s.dataset.nav;
s.classList.toggle('lp-active', num === n);
s.classList.toggle('lp-done', num < n);
});
if(n === 2) renderQuestion();
if(n === 3) renderResult();
setTimeout(function(){
var target;
if(n === 1) target = quizRoot.querySelector('.lp-quiz__cart');
else if(n === 2) target = quizRoot.querySelector('.lp-qquestion');
else target = quizRoot.querySelector('.lp-qresult__scorecard');
if(!target) target = quizRoot;
target.scrollIntoView({behavior:'smooth', block:'center'});
}, 80);
}
blocks.forEach(function(b){
b.addEventListener('click', function(){
var svc = b.dataset.service;
if(selected.has(svc)){ selected.delete(svc); b.classList.remove('lp-selected'); }
else { selected.add(svc); b.classList.add('lp-selected'); }
renderCart();
if(qNext1) qNext1.disabled = selected.size === 0;
});
});
function renderCart(){
if(!cart) return;
if(selected.size === 0){
cart.innerHTML = '<span class="lp-quiz__cart-empty">Ihre Auswahl erscheint hier ↓</span>';
return;
}
var html = '';
selected.forEach(function(svc){
var m = LABEL_MAP[svc]; if(!m) return;
html += '<span class="ptype ptype--'+m.color+'"><span class="lp-ptype__dot"></span>'+m.label+'</span>';
});
cart.innerHTML = html;
}
if(qNext1) qNext1.addEventListener('click', function(){ current = 0; answers = []; goStep(2); });
function renderQuestion(){
if(!qProgress) return;
var dots = '';
for(var i = 0; i < QUESTIONS.length; i++){
var cls = 'qprogress-dot';
if(answers[i] !== undefined) cls += ' done';
if(i === current) cls += ' current';
dots += '<span class="'+cls+'"></span>';
}
qProgress.innerHTML = dots;
if(qQNum) qQNum.textContent = 'Frage '+(current+1)+' von '+QUESTIONS.length;
if(qQText) qQText.textContent = QUESTIONS[current].text;
qOpts.forEach(function(o){ o.classList.remove('lp-selected'); });
if(answers[current] !== undefined){
qOpts.forEach(function(o){ if(+o.dataset.val === answers[current]) o.classList.add('lp-selected'); });
}
}
qOpts.forEach(function(opt){
opt.addEventListener('click', function(){
answers[current] = +opt.dataset.val;
qOpts.forEach(function(o){o.classList.remove('lp-selected');});
opt.classList.add('lp-selected');
setTimeout(function(){
if(current < QUESTIONS.length - 1){ current++; renderQuestion(); }
else { goStep(3); }
}, 320);
});
});
if(qBack2) qBack2.addEventListener('click', function(){
if(current > 0){ current--; renderQuestion(); }
else { goStep(1); }
});
function computeScore(){ return answers.reduce(function(s, v){ return s + (v || 0); }, 0); }
function scoreLevel(score){
if(score <= 3) return { level:'Digitalisierungs-Potenzial: <em>Groß</em>', tone:'big' };
if(score <= 7) return { level:'Digitalisierungs-Potenzial: <em>Mittel</em>', tone:'medium' };
return { level:'Bereits <em>gut aufgestellt</em>', tone:'good' };
}
function computeSuggestions(){
var suggested = new Map();
answers.forEach(function(ans, idx){
if(ans === undefined || ans >= 2) return;
var q = QUESTIONS[idx]; if(!q) return;
var svc = q.service;
if(selected.has(svc)) return;
if(!suggested.has(svc)) suggested.set(svc, []);
suggested.get(svc).push(q.key);
});
return suggested;
}
function animateCount(el, from, to, dur){
if(!el) return;
var start = performance.now();
function tick(now){
var t = Math.min(1, (now - start) / dur);
var eased = 1 - Math.pow(1 - t, 3);
el.textContent = Math.round(from + (to - from) * eased);
if(t < 1) requestAnimationFrame(tick);
}
requestAnimationFrame(tick);
}
function renderResult(){
var score = computeScore();
animateCount(qScore, 0, score, 900);
var lvl = scoreLevel(score);
if(qLevel) qLevel.innerHTML = lvl.level;
if(qSelectedChips){
var sel = '';
if(selected.size === 0){ sel = '<span class="lp-quiz__cart-empty" style="opacity:.5">Keine Auswahl</span>'; }
else { selected.forEach(function(svc){
var m = LABEL_MAP[svc]; if(!m) return;
sel += '<span class="ptype ptype--'+m.color+'"><span class="lp-ptype__dot"></span>'+m.label+'</span>';
});}
qSelectedChips.innerHTML = sel;
}
var suggested = computeSuggestions();
if(suggested.size > 0 && qSuggestBlock){
var chips = ''; var reasons = [];
suggested.forEach(function(qKeys, svc){
var m = LABEL_MAP[svc]; if(!m) return;
chips += '<span class="ptype ptype--'+m.color+'"><span class="lp-ptype__dot"></span>'+m.label+'</span>';
reasons.push('<b>'+m.label+':</b> ' + (REASONS[svc]||''));
});
if(qSuggestedChips) qSuggestedChips.innerHTML = chips;
if(qReasoning) qReasoning.innerHTML = reasons.join('<br><br>');
qSuggestBlock.style.display = 'block';
if(qSufficientBlock) qSufficientBlock.style.display = 'none';
} else if(qSufficientBlock){
if(qSuggestBlock) qSuggestBlock.style.display = 'none';
qSufficientBlock.style.display = 'block';
if(qReasoningOK){
if(score >= 8) qReasoningOK.innerHTML = '<b>Sehr gut.</b> Ihre digitale Basis steht — die Auswahl passt zur Situation. Wir helfen bei der konkreten Umsetzung.';
else if(selected.size === 0) qReasoningOK.innerHTML = 'Sie haben noch nichts ausgewählt — kein Problem. Schreiben Sie uns einfach, worum es geht.';
else qReasoningOK.innerHTML = '<b>Ihre Auswahl passt gut zu Ihrem Status.</b> Kein zusätzlicher Hebel nötig — direkt in die Umsetzung.';
}
}
if(qCta){
var services = Array.from(selected).join(',');
var suggestedList = Array.from(suggested.keys()).join(',');
var params = new URLSearchParams();
if(services) params.set('services', services);
params.set('score', score);
params.set('level', lvl.tone);
if(suggestedList) params.set('suggested', suggestedList);
qCta.href = kontaktUrl + '?' + params.toString() + '#form';
}
}
if(qRestart) qRestart.addEventListener('click', function(){
selected.clear(); answers = []; current = 0;
blocks.forEach(function(b){b.classList.remove('lp-selected');});
renderCart();
if(qNext1) qNext1.disabled = true;
goStep(1);
});
})();
/* =========================================================================
SO ARBEITEN WIR: chaos→ordnung scroll animation + FAQ accordion
========================================================================= */
(function(){
'use strict';
/* -------- CHAOS → ORDNUNG SCROLL ANIMATION -------- */
var section = document.querySelector('.fx-lp .lp-chaos');
var svg = section ? section.querySelector('.lp-chaos__svg') : null;
/* Mobile + reduced-motion: skip heavy scroll animation, jump to end-state.
   Saves ~2s TBT on mobile + battery + prevents 180vh sticky viewport hog. */
var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var mqMobile = window.matchMedia('(max-width: 820px)').matches;
var mobileCompact = section && section.getAttribute('data-mobile-compact') === '1';
var lightMode = mqReduce || (mqMobile && mobileCompact);
if(section && svg){
var intro = section.querySelector('.lp-chaos__intro');
var progressEl = section.querySelector('.lp-chaos__progress');
var leftLabel = section.querySelector('.lp-chaos-left');
var rightLabel = section.querySelector('.lp-chaos-right');
var COUNT = 80, GROUPS = 4, PER_GROUP = COUNT / GROUPS;
var W = 1000, H = 500, AXIS_Y = 130, AXIS_X1 = 100, AXIS_X2 = 900;
var NODES = [];
for(var n = 0; n < GROUPS; n++){
var t = n / (GROUPS - 1);
NODES.push({x: AXIS_X1 + t * (AXIS_X2 - AXIS_X1), y: AXIS_Y});
}
var seed = 42;
function rand(){ seed = (seed*9301 + 49297) % 233280; return seed/233280; }
var dots = [];
for(var i = 0; i < COUNT; i++){
var g = Math.floor(i / PER_GROUP);
var withinGroup = i % PER_GROUP;
var chaosX = 80 + rand() * (W - 160);
var chaosY = 170 + rand() * 260;
var localCol = withinGroup % 4;
var localRow = Math.floor(withinGroup / 4);
var node = NODES[g];
var orderX = node.x + (localCol - 1.5) * (70/3) + (rand()-.5)*8;
var orderY = AXIS_Y + 40 + localRow * (120/4) + (rand()-.5)*4;
var radius = 3 + rand() * 2.5;
var delay = rand();
dots.push({group:g, chaosX:chaosX, chaosY:chaosY, orderX:orderX, orderY:orderY, r:radius, delay:delay});
}
// Labels come from the DOM (populated by Liquid from section blocks / settings)
var LABELS_DATA = svg.dataset.labels ? JSON.parse(svg.dataset.labels) : [
{num:'01 · Zuhören', name:'Analyse'},
{num:'02 · Zeichnen', name:'Konzept'},
{num:'03 · Bauen', name:'Umsetzung'},
{num:'04 · Begleiten', name:'Betrieb'}
];
var TITLE_TEXT = svg.dataset.title || '— Vier Phasen —';
var axisLen = AXIS_X2 - AXIS_X1;
var content = '';
content += '<line class="lp-chaos-axis" x1="'+AXIS_X1+'" y1="'+AXIS_Y+'" x2="'+AXIS_X2+'" y2="'+AXIS_Y+'" stroke-dasharray="'+axisLen+'" stroke-dashoffset="'+axisLen+'"/>';
content += '<polyline class="lp-chaos-arrow" points="'+(AXIS_X2-14)+','+(AXIS_Y-8)+' '+(AXIS_X2+4)+','+AXIS_Y+' '+(AXIS_X2-14)+','+(AXIS_Y+8)+'"/>';
dots.forEach(function(d, i){
content += '<circle class="lp-chaos-dot" data-i="'+i+'" cx="'+d.chaosX+'" cy="'+d.chaosY+'" r="'+d.r+'"/>';
});
NODES.forEach(function(node, i){
content += '<circle class="lp-chaos-node" data-n="'+i+'" cx="'+node.x+'" cy="'+node.y+'" r="0"/>';
});
function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
content += '<text class="lp-chaos-labels-title" x="500" y="410" text-anchor="middle">'+esc(TITLE_TEXT)+'</text>';
LABELS_DATA.forEach(function(l, i){
if(!NODES[i]) return;
var node = NODES[i];
content += '<text class="lp-chaos-label-num" data-idx="'+i+'" x="'+node.x+'" y="443" text-anchor="middle">'+esc(l.num||'')+'</text>';
content += '<text class="lp-chaos-label-name" data-idx="'+i+'" x="'+node.x+'" y="478" text-anchor="middle">'+esc(l.name||'')+'</text>';
});
svg.innerHTML = content;
var axis = svg.querySelector('.lp-chaos-axis');
var arrow = svg.querySelector('.lp-chaos-arrow');
var dotEls = svg.querySelectorAll('.lp-chaos-dot');
var nodeEls = svg.querySelectorAll('.lp-chaos-node');
var titleEl = svg.querySelector('.lp-chaos-labels-title');
var labelNums = svg.querySelectorAll('.lp-chaos-label-num');
var labelNames = svg.querySelectorAll('.lp-chaos-label-name');
// Performance: pause scroll updates when section is offscreen
var visible = true;
if('IntersectionObserver' in window){
new IntersectionObserver(function(entries){
visible = entries[0].isIntersecting;
}, {rootMargin: '200px'}).observe(section);
}
function update(){
if(!visible) return;
var rect = section.getBoundingClientRect();
var vh = window.innerHeight;
var total = rect.height - vh;
var scrolled = -rect.top;
var progress = Math.max(0, Math.min(1, scrolled / total));
if(lightMode) progress = 1;
if(intro) intro.style.opacity = 1 - Math.min(1, progress * 2.2);
if(leftLabel) leftLabel.style.opacity = progress > 0.05 && progress < 0.5 ? 1 : 0;
if(rightLabel) rightLabel.style.opacity = progress > 0.45 ? 1 : 0;
if(progressEl) progressEl.style.opacity = Math.max(0, 0.5 - progress);
dotEls.forEach(function(c, i){
var d = dots[i];
var localWindow = 0.55;
var localProgress = Math.max(0, Math.min(1, (progress - d.delay * 0.15) / (localWindow - d.delay * 0.15)));
var ease = 1 - Math.pow(1 - localProgress, 3);
var x = d.chaosX + (d.orderX - d.chaosX) * ease;
var y = d.chaosY + (d.orderY - d.chaosY) * ease;
c.setAttribute('cx', x);
c.setAttribute('cy', y);
});
var axisProg = Math.max(0, Math.min(1, (progress - 0.55) / 0.17));
axis.setAttribute('stroke-dashoffset', axisLen * (1 - axisProg));
var nodeMaxR = 9;
nodeEls.forEach(function(n, i){
var nodeStart = 0.72 + i * 0.02;
var nodeProg = Math.max(0, Math.min(1, (progress - nodeStart) / 0.05));
var r = nodeMaxR * (1 - Math.pow(1 - nodeProg, 2));
n.setAttribute('r', r);
});
var arrowProg = Math.max(0, Math.min(1, (progress - 0.82) / 0.06));
arrow.style.opacity = arrowProg;
if(titleEl) titleEl.classList.toggle('lp-in', progress > 0.80);
labelNums.forEach(function(el, i){
var appear = 0.86 + i * 0.025;
el.classList.toggle('lp-in', progress > appear);
if(labelNames[i]) labelNames[i].classList.toggle('lp-in', progress > appear + 0.015);
});
}
update();
window.addEventListener('scroll', update, {passive: true});
window.addEventListener('resize', update);
if(lightMode){
section.style.minHeight = 'auto';
var sticky = section.querySelector('.lp-chaos__sticky');
if(sticky) sticky.style.minHeight = 'auto';
}
}
/* -------- FAQ ACCORDION -------- */
document.querySelectorAll('.fx-lp .lp-faq__item').forEach(function(item){
item.addEventListener('click', function(){ item.classList.toggle('lp-open'); });
});
})();
/* =========================================================================
BLOG: category filter + reading progress bar
========================================================================= */
(function(){
'use strict';
/* -------- Blog category filter (visual only — active state) -------- */
document.querySelectorAll('.fx-lp .lp-blog-cat').forEach(function(c){
c.addEventListener('click', function(){
var parent = c.parentElement;
if(!parent) return;
parent.querySelectorAll('.lp-blog-cat').forEach(function(x){
x.classList.remove('lp-active');
});
c.classList.add('lp-active');
});
});
/* -------- Reading progress bar for blog post -------- */
/* Tracks the whole document scroll (not article height) — makes the
bar work regardless of where <article> tag opens/closes across sections. */
var bar = document.querySelector('.fx-lp .lp-reading-progress');
if(bar){
function updateProgress(){
var doc = document.documentElement;
var scrollTop = window.pageYOffset || doc.scrollTop || 0;
var total = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight;
var pct = total > 0 ? Math.max(0, Math.min(100, (scrollTop / total) * 100)) : 0;
bar.style.width = pct + '%';
}
window.addEventListener('scroll', updateProgress, {passive:true});
window.addEventListener('resize', updateProgress);
updateProgress();
}
})();
/* =========================================================================
KONTAKT: chip toggle + URL-param prefill from Leistungen quiz
========================================================================= */
(function(){
'use strict';
/* -------- Chip single-select toggle -------- */
document.querySelectorAll('.fx-lp .lp-chip-group').forEach(function(group){
group.querySelectorAll('.lp-chip').forEach(function(chip){
chip.addEventListener('click', function(){
group.querySelectorAll('.lp-chip').forEach(function(x){
x.classList.remove('lp-active');
});
chip.classList.add('lp-active');
});
});
});
/* -------- URL-param prefill from Leistungen quiz -------- */
/* Quiz link format: /pages/kontakt?services=shop,ki&score=6&level=medium&suggested=marketing#form */
var params = new URLSearchParams(window.location.search);
if(!params.has('services') && !params.has('score')) return;
var services = (params.get('services') || '').split(',').filter(Boolean);
var suggested = (params.get('suggested') || '').split(',').filter(Boolean);
var score = params.get('score') || '';
var level = params.get('level') || '';
/* Map quiz service keys to chip labels visible in the form */
var LABELS = {
shop:'Shopify-Store',
portal:'Prozesse optimieren',
website:'Etwas anderes',
beratung:'Etwas anderes',
schulung:'Etwas anderes',
marketing:'Etwas anderes',
ki:'KI-Automation',
unclear:'Etwas anderes'
};
var FULLLABELS = {
shop:'Shop / E-Commerce',
portal:'Portal / ERP-System',
website:'Website / Firmenpräsentation',
beratung:'Beratung + Hardware-Setup',
schulung:'Team-Schulung',
marketing:'Marketing (mit GOA)',
ki:'KI & Automation',
unclear:'Erstgespräch — noch unklar'
};
var LEVELS = { big:'Groß', medium:'Mittel', good:'Bereits gut aufgestellt' };
/* Activate matching chip in first chip-group */
var mapped = services.length && LABELS[services[0]] ? LABELS[services[0]] : 'Etwas anderes';
document.querySelectorAll('.fx-lp .lp-chip-group .lp-chip').forEach(function(c){
c.classList.remove('lp-active');
if(c.textContent.trim() === mapped) c.classList.add('lp-active');
});
/* Prefill the message textarea */
var msg = 'Aus dem Leistungen-Profil auf Ihrer Website:\n\n';
if(services.length){
msg += 'Interesse: ' + services.map(function(s){ return FULLLABELS[s] || s; }).join(', ') + '.\n';
}
if(score){
var lvlText = LEVELS[level] || '';
msg += 'Digitalisierungs-Status: ' + score + '/10';
if(lvlText) msg += ' (' + lvlText + ')';
msg += '.\n';
}
if(suggested.length){
msg += 'Zusätzliche Empfehlung aus dem Check: ' + suggested.map(function(s){ return FULLLABELS[s] || s; }).join(', ') + '.\n';
}
msg += '\nBitte um Rückmeldung mit ersten Ideen.';
var textarea = document.querySelector('.fx-lp .lp-kontakt-form textarea');
if(textarea) textarea.value = msg;
/* Scroll to form anchor after 300ms */
setTimeout(function(){
var anchor = document.getElementById('form');
if(anchor) anchor.scrollIntoView({ behavior:'smooth', block:'start' });
}, 300);
})();
/* ============================================================================
ROI-RECHNER — ACCESSIBILITY PATCH
Wklej to na SAM KONIEC assets/fx-core.js (albo dowolnego globalnego JS)
Problem: PageSpeed a11y raportuje 4 range inputs bez labels:
- #roiHours-* → potrzeba "Stunden pro Woche"
- #roiPeople-* → potrzeba "Anzahl Mitarbeiter"
- #roiRate-* → potrzeba "Stundensatz (EUR)"
- #roiAuto-* → potrzeba "Automatisierungsgrad (%)"
Fix: JS auto-dodaje aria-label na wszystkie te range inputs. Bez konieczności
edycji sekcji ROI-Rechner. Działa dla wszystkich instancji (nawet gdyby było
ich kilka na stronie).
============================================================================ */
(function(){
'use strict';
var labels = {
'roiHours': 'Stunden pro Woche für manuelle Prozesse',
'roiPeople': 'Anzahl Mitarbeiter im Team',
'roiRate': 'Durchschnittlicher Stundensatz in Euro',
'roiAuto': 'Automatisierungsgrad in Prozent'
};
Object.keys(labels).forEach(function(key){
/* id starts-with lub exact match */
document.querySelectorAll('input[id^="' + key + '"]').forEach(function(input){
if(!input.hasAttribute('aria-label')){
input.setAttribute('aria-label', labels[key]);
}
});
});
/* Fix heading order — H4 "Analyse" przed H2, H5 "FUTUREMAXX UG" bez H3/H4 */
/* Change to correct semantic level via aria-level (visual size stays same via CSS) */
document.querySelectorAll('h4').forEach(function(h){
if(h.textContent.trim().toLowerCase() === 'analyse'){
/* If this h4 appears BEFORE any h2 on page, downgrade to h3 semantically */
var beforeH2 = true;
var walker = h;
while(walker = walker.previousElementSibling){
if(walker.tagName === 'H2'){ beforeH2 = false; break; }
}
if(beforeH2){
h.setAttribute('role', 'heading');
h.setAttribute('aria-level', '3');
}
}
});
document.querySelectorAll('h5').forEach(function(h){
/* H5 without preceding H3/H4 — fix by setting aria-level based on position */
var text = h.textContent.trim();
if(text.indexOf('FUTUREMAXX') === 0 || text === 'Kontakt' || text === 'Unternehmen' || text === 'Leistungen'){
/* Footer columns — should be H4 semantically (main content ends before) */
h.setAttribute('role', 'heading');
h.setAttribute('aria-level', '4');
}
});
})();
